import CssBaseline from '@mui/material/CssBaseline';
import { ThemeProvider } from '@mui/material/styles';
import DialogProvider from './contexts/dialog/provider';
import DefaultLayout from './layouts/DefaultLayout';
import htmlGlobalStyles from './style/htmlGlobalStyles';
import theme from './style/theme';
import validateApplicationConfiguration from './utils/validateApplicationConfiguration';
import DefaultView from './views/DefaultView';
import InvalidApplicationConfigurationView from './views/InvalidApplicationConfigurationView';
// import ConfiguredPageGeneratorView from './views/ConfiguredPagesGeneratorView';

function App() {
  const applicationConfigurationIsValid = validateApplicationConfiguration();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {htmlGlobalStyles}
      {applicationConfigurationIsValid === true ? (
        <DialogProvider>
          <DefaultLayout>
            <DefaultView />
          </DefaultLayout>
        </DialogProvider>
      ) : (
        <InvalidApplicationConfigurationView
          errorMessage={applicationConfigurationIsValid.errorMessage}
        />
      )}
    </ThemeProvider>
    // <ConfiguredPageGeneratorView />
  );
}

export default App;
